import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TextHighlightComponent } from './text-highlight.component';

@NgModule({
    imports: [CommonModule],
    declarations: [TextHighlightComponent],
    exports: [TextHighlightComponent],
})
export class TextHighlightModule {}
